import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { useDocumentTitle } from '~/hooks';
import { Header, Page } from '../../components';
import ConversationDetail from './ConversationDetail';
import ConversationList from './ConversationList';

export default function AiReplay() {
  useDocumentTitle('AI Replay - Admin');

  const { path } = useRouteMatch();

  return (
    <Page>
      <Header />
      <Switch>
        <Route exact path={path}>
          <ConversationList />
        </Route>
        <Route path={`${path}/:conversationId`}>
          <ConversationDetail />
        </Route>
      </Switch>
    </Page>
  );
}
